import { withExtraArgument } from 'redux-thunk'

import type { Context } from '@app/packages/actionContext/Context'

import type { ReduxMiddleware } from './types'

export const StoreMiddlewares = (context: Context): ReduxMiddleware<any>[] => [withExtraArgument(context)]
